import { render, staticRenderFns } from "./MessageRecharge.vue?vue&type=template&id=620e2c84&scoped=true&"
import script from "./MessageRecharge.vue?vue&type=script&lang=js&"
export * from "./MessageRecharge.vue?vue&type=script&lang=js&"
import style0 from "./MessageRecharge.vue?vue&type=style&index=0&id=620e2c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620e2c84",
  null
  
)

export default component.exports